import Box from '@mui/material/Box';
import React from 'react';
import SelectIcon from './icon-button';

interface HiddenDesktopLabelProps {
	id: string;
	label: React.ReactNode;
	modal?: boolean;
	isMobile?: boolean;
	onIconClick: () => void;
}

export const HiddenDesktopLabel: React.FC<HiddenDesktopLabelProps> = ({ id, label, modal, isMobile, onIconClick }) => {
	return (
		<Box
			sx={{
				display: { xs: 'block', md: 'none' },
			}}
		>
			{isMobile && modal ? (
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						width: '100%',
						backgroundColor: 'background.paper',
						gap: 1,
					}}
				>
					<Box sx={{ flex: 1 }}>{label}</Box>
					<SelectIcon id={id} onClick={onIconClick} isMobile={isMobile} />
				</Box>
			) : (
				label
			)}
		</Box>
	);
};
